/**
 * Bookmark event keys.
 */
const BookmarkEvents = {
    /*
     * Emitted when a bookmark has been successfully added.
     * Payload is the newly added bookmark object.
     */
    added: "Bookmark.added",
    /*
     * Emitted when a bookmark is deleted.
     * Payload is the code (course code or program code) of the bookmark which was deleted.
     */
    deleted: "Bookmark.deleted"
};
export default BookmarkEvents;